/* eslint-disable import/prefer-default-export */
import NBType from '@netbase/nb-type'

export const toExternal = (data = {}) => {
  return NBType.toExternal(data)
}
